import React from 'react'
import selectn      from 'selectn'

const MatchDetailItem = ({
  type = '',
  persons = [],
  value = '',
  enableLink = false
}) => {
  const len = persons.length
  if(len > 0) {
    persons = persons.map((p,i) => {
      if (enableLink === true && p.href !== '#') {
        return `<a href=${p.href}>${p.name}</a>`
      } else {
        let separator = ''

        // add separator if more than one item
        if (i > 0) {
          // `and` if last item
          if (i == len -1) {
            separator = ' and '
          } else {
            // `,` if middle item
            separator = ', '
          }
        }

        return separator + p.name
      }
    })
  }

  persons = persons.join('')

  return (
    <tr className="cricinfo__table__tr">
    {
      <td className="cricinfo__table__td">
        <span className="cricinfo__type__weight--bold">{ type || '' }: </span>
        { persons.length > 0 && <span dangerouslySetInnerHTML={{ __html: persons }}/> }
        { value.length > 0 && value }
      </td>
    }
    </tr>
  )
}

const MatchDetails = ({
  officials = {},
  debuts = [],
  toss = '',
  matchFormat = '',
  series = [],
  featuredAthletesDetails = []
}) => {

  const umpire = officials.umpire && officials.umpire || []
  const tvUmpire = officials['tv umpire'] && officials['tv umpire'] || []
  const reserveUmpire = officials['reserve umpire'] && officials['reserve umpire'] || []
  const referee = officials.referee && officials.referee || []  
  const props = [
    debuts.length,
    umpire.length,
    tvUmpire.length,
    reserveUmpire.length,
    referee.length,
    matchFormat,
    featuredAthletesDetails.length
  ]
  let show = false

  // loops through all props and sets show=true
  // if any one of them is available
  for (var i = 0; i < props.length; i++) {
    if(props[i]) {
      show = true
    }
  }
  const content = (
    <div className="cricinfo__content__item">
      <h2 className="cricinfo__sub-title">Match Details</h2>
      <table className="cricinfo__table">
        <tbody>
        {
          series.length && 
          <MatchDetailItem type="Series" persons={series} enableLink={true} /> || null
        }
        {
          toss && <MatchDetailItem type="Toss" persons={[]} value={toss} /> || null
        }
        {
          featuredAthletesDetails && featuredAthletesDetails.map( (item, i)=> {
            if (item[1].length === 0) {
              return null
            }
            const featuredAthleteType = selectn('[0].featuredAthletesType', item[1]) || ''
            return <MatchDetailItem key={i} type={featuredAthleteType} persons={item[1]} />
          })
        }
        {
          debuts.length &&
          <MatchDetailItem type={matchFormat + ' debut'} value="" persons={debuts} /> || null
        }
        {
          umpire.length &&
          <MatchDetailItem type="Umpires" value="" persons={officials.umpire} /> || null
        }
        {
          tvUmpire.length &&
          <MatchDetailItem type="TV Umpires" value="" persons={officials['tv umpire']} /> || null
        }
        {
          reserveUmpire.length &&
          <MatchDetailItem type="Reserve Umpire" value="" persons={officials['reserve umpire']} /> || null
        }
        {
          referee.length &&
          <MatchDetailItem type="Match Referee" value="" persons={officials.referee} /> || null
        }
        </tbody>
      </table>
    </div>
  )

  return show ? content : <div style={{ display:'none' }}/>
}

export default MatchDetails



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/lite/MatchDetails.jsx